import { ThunderboltFilled, ThunderboltOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { amplitudeTrack } from 'app/utils/track/amplitude';

type Props = {
  hasActivatedPricingRule: boolean;
  setIsPricingRuleModalOpen: (value: boolean) => void;
};

export const ButtonDefaultDiscount = ({
  hasActivatedPricingRule,
  setIsPricingRuleModalOpen,
}: Props) => {
  const clickButtonPricingRule = () => {
    hasActivatedPricingRule
      ? amplitudeTrack('Click Pricing rule activated')
      : amplitudeTrack('Click Activate pricing rule');
    setIsPricingRuleModalOpen(true);
  };

  const iconPricingRule = hasActivatedPricingRule ? (
    <ThunderboltFilled />
  ) : (
    <ThunderboltOutlined />
  );

  const buttonText = hasActivatedPricingRule
    ? 'Default discount activated'
    : 'Activate default discount';

  return (
    <Button
      icon={iconPricingRule}
      onClick={clickButtonPricingRule}
      className="AutoInventoryButton"
    >
      {buttonText}
    </Button>
  );
};
